export const ERROR_MSG = 'กรุณากรอกข้อมูลให้ครบถ้วน';
export const ERROR_FULLNAME_MSG = 'กรุณากรอกชื่อของคุณ';
export const ERROR_TEL_MSG = 'กรุณากรอกเบอร์โทรศัพท์';
